import { FC, useState } from 'react';
import Heading from '../chat/Heading';
import { Container } from '../../styles/chime-react/CommonStyles';
import Label from '../chat/Label';
import Checkbox from '../chat/Checkbox';
import PrimaryButton from '../chat/Button/PrimaryButton';
import {
  StyledTermAgreeCheckList,
  StyledTermBottom,
  StyledTermBox,
  StyledTermList
} from './Styled';
import { StyledCloseLink } from '../walkthrough/Styled';
import { useDebouncedCallback } from 'use-debounce';
import LineTermText from '../common/TermText/LineTermText';

export type DisclaimerType = 'line' | null;

const Disclaimer: FC<{ onSubmit: () => void; type?: DisclaimerType }> = ({
  type,
  onSubmit
}) => {
  const [hasAgreedLine, setAgreedLine] = useState(false);

  const onSumbitDebounced = useDebouncedCallback(onSubmit, 3_000, {
    leading: true,
    trailing: false
  });
  return (
    <Container>
      <Heading
        level={1}
        tag="h1"
        alignCenter={true}
        color="primary"
        mb={{ _: '1rem', md: '2rem' }}
      >
        ご利用について
      </Heading>

      <StyledTermList>
        {type === 'line' && (
          <div>
            <Heading
              level={3}
              tag="h2"
              color="primary"
              mb={{ _: '0.5rem', md: '1rem' }}
            >
              コネクト サービス利用要領
            </Heading>
            <StyledTermBox>
              <Heading
                level={6}
                tag="h3"
                alignCenter={true}
                marginBottom="1rem"
              >
                【ご利用にあたっての注意事項】
              </Heading>
              <LineTermText />
            </StyledTermBox>
          </div>
        )}
      </StyledTermList>
      <StyledTermBottom>
        <StyledTermAgreeCheckList>
          {type === 'line' && (
            <Label normalText>
              <Checkbox
                value={hasAgreedLine ? '1' : '0'}
                checked={hasAgreedLine}
                onChange={(event) =>
                  setAgreedLine((event.target as HTMLInputElement).checked)
                }
              />
              コネクト サービスの利用要領に同意する
            </Label>
          )}
        </StyledTermAgreeCheckList>

        <PrimaryButton
          className="agree-button"
          label="次へ"
          onClick={onSumbitDebounced}
          disabled={type === 'line' && !hasAgreedLine}
        />

        <StyledCloseLink
          onClick={() => {
            window.opener = null;
            window.open('', '_self');
            window.close();
          }}
        >
          中止してこの画面を閉じる
        </StyledCloseLink>
      </StyledTermBottom>
    </Container>
  );
};

export default Disclaimer;
